module.exports = __webpack_public_path__ + "img/Hierkonpolku_DSC_9174_Terhi Ajosenpää_800px.3a49fa08.jpg";